import { romeApi, utils } from "framework";

const state = {
  employerEnrollmentId: null,
  employerId: null,
  editable: null,
  enrollmentType: null,
  openEnrollmentStartDate: null,
  openEnrollmentEndDate: null
};

const getters = {};

const actions = {
  async getEmployerEnrollment({ commit, rootState },data) {
    let id = rootState.employer.employerId;
    if (data && data.employerId) id = data.employerId;
    if (!id) return;
    let enrollmentInfo = await romeApi.get(`/employer/${id}/enrollment-type`);
    
        if (!enrollmentInfo) {
            commit('clearEmployerEnrollment');
            commit('setEmployerId',id);
        }
        else {
            commit('setEmployerEnrollment', enrollmentInfo);
        } 
  },
  async updateEmployerEnrollment({ commit, dispatch, rootState, state }, enrollmentData) {
    let id = rootState.employer.employerId;
    if (!id) return;

    await romeApi.post(`/employer/${id}/enrollment-type`, enrollmentData);

    dispatch('getEmployerEnrollment');
  },
  
};

const mutations = {
  setEmployerEnrollment(state, data) {
      utils.copyCommonProperties(data, state);
  },
  setEmployerId(state,data)
  {
    state.employerId = data;
  },
  clearEmployerEnrollment(state) {
    Object.keys(state).forEach(p => state[p] = null);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/employer/x-employer-enrollment.js